<template>
  <div class="section has-text-centered" :style="'background-color:' + backgroundColor">
    <div class="subtitle " v-if="subtitle">{{subtitle}}</div>
    <div class="title" v-if="title">{{title}}</div>
    <img src="../assets/next-arrow.svg" class="arrow">
  </div>
</template>

<script>
  export default {
    props: ['backgroundColor', 'subtitle', 'title']
  }
</script>
<style lang="scss" scoped>
.title, .subtitle {
  color: #fff;
}
</style>